import { UGS_SHEET_MODES } from 'constants/unguided-sheet';

import { createActionWithPayload } from './utils';

const {} = UGS_SHEET_MODES;

export const ACTIONS = {
  SET_FIRST_CAMERA_ERRORED_TIME: 'SET_FIRST_CAMERA_ERRORED_TIME',
  CLEAR_FIRST_CAMERA_ERRORED_TIME: 'CLEAR_FIRST_CAMERA_ERRORED_TIME',
  SET_CAMERA_UNAVAILABLE: 'SET_CAMERA_UNAVAILABLE',
  SET_CAN_ENTER_WITHOUT_CAMERA: 'SET_CAN_ENTER_WITHOUT_CAMERA',
  SET_LEARNING_MODE: 'SET_LEARNING_MODE',
  DELETE_LEARNING_MODE: 'DELETE_LEARNING_MODE',
  UPDATE_TEACHER_AV_STATE: 'UPDATE_TEACHER_AV_STATE',
} as const;

enum SheetMode {
  'STARTED_UGS_SHEET',
  'ENDED_UGS_SHEET',
  'STARTED_UGS_SHEET_REVIEW',
  'ENDED_UGS_SHEET_REVIEW',
  'END_UGS_EXPERIENCE',
}

export const setFirstCameraErroredTime = createActionWithPayload<
  typeof ACTIONS.SET_FIRST_CAMERA_ERRORED_TIME,
  {
    teacherClassroomId: string;
    time: number;
  }
>(ACTIONS.SET_FIRST_CAMERA_ERRORED_TIME);

export const clearFirstCameraErroredTime = createActionWithPayload<
  typeof ACTIONS.CLEAR_FIRST_CAMERA_ERRORED_TIME,
  { teacherClassroomId: string }
>(ACTIONS.CLEAR_FIRST_CAMERA_ERRORED_TIME);

export const setCameraUnavailable = createActionWithPayload<
  typeof ACTIONS.SET_CAMERA_UNAVAILABLE,
  { teacherClassroomId: string }
>(ACTIONS.SET_CAMERA_UNAVAILABLE);

export const setCanEnterWithoutCamera = createActionWithPayload<
  typeof ACTIONS.SET_CAN_ENTER_WITHOUT_CAMERA,
  { teacherClassroomId: string }
>(ACTIONS.SET_CAN_ENTER_WITHOUT_CAMERA);

export const subscribeUGLearningMode = createActionWithPayload<
  typeof ACTIONS.SET_LEARNING_MODE,
  {
    teacherClassroomId: string;
    sheet_type: string;
    sheet_mode: keyof typeof SheetMode;
    all_questions_correct?: boolean;
  }
>(ACTIONS.SET_LEARNING_MODE);

export const unSubscribeUGLearningMode = createActionWithPayload<
  typeof ACTIONS.DELETE_LEARNING_MODE,
  { teacherClassroomId: string }
>(ACTIONS.DELETE_LEARNING_MODE);

export const updateTeacherAVState = createActionWithPayload<
  typeof ACTIONS.UPDATE_TEACHER_AV_STATE,
  {
    teacherClassroomId: string;
    activeStudentId?: string;
    onMute: boolean;
    onHold: boolean;
  }
>(ACTIONS.UPDATE_TEACHER_AV_STATE);
